import React from 'react';

function PageNotFound() {
    return (
        <h1 style={{color: 'white'}}>La pagina richiesta non è stata trovata o non si dispone di autorizzazioni per accederci.</h1>
    );
}

export default PageNotFound;
